import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CardVariants } from "@app/shared/types/card-variants.type";

@Component({
    selector: 'lpcr-app-card',
    templateUrl: './card.component.html',
    imports: [NgClass]
})
export class CardComponent {
  /**
   * Gets or sets the card variant color.
   */
  @Input()
  public variant: CardVariants = "plain";
}
